import React from "react";
import type { CSSProperties } from "react";
import { TEMPLATE_MAX_WIDTH_VAR } from "@openings/template-components";

// ---------------------------------------------------------------------------
// BookingPageWrapper — consistent centered container with responsive padding
// ---------------------------------------------------------------------------

const WRAPPER_CLASS = "openings-booking-wrapper";

const WRAPPER_STYLES = `
  .${WRAPPER_CLASS} {
    width: 100%;
    max-width: ${TEMPLATE_MAX_WIDTH_VAR};
    margin: 0 auto;
    padding: 16px
      var(--openings-booking-editorial-outer-padding, 32px);
    box-sizing: border-box;
  }
  @media (max-width: 767px) {
    .${WRAPPER_CLASS} {
      padding: 12px
        var(--openings-booking-editorial-outer-padding, 16px);
    }
  }
`;

type BookingPageWrapperProps = {
  children: React.ReactNode;
  className?: string;
  style?: CSSProperties;
};

export function BookingPageWrapper({
  children,
  className,
  style,
}: BookingPageWrapperProps) {
  return (
    <>
      <style>{WRAPPER_STYLES}</style>
      <div
        className={className ? `${WRAPPER_CLASS} ${className}` : WRAPPER_CLASS}
        style={style}
      >
        {children}
      </div>
    </>
  );
}
